import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { setErrorList, setLineOfBusiness } from '../../redux/actions';
import history from '../../../history';
import Vehicle from '../../auto/vehicle';
import { INSURANCE_PRODUCTS } from '../../../constants';

const AutoForm = ({
  onNextTab,
  onPrevTab,
  currentIndex,
  setLineOfBusiness,
  setErrorList,
  add,
  goToLastTab,
}: AppComponents.AutoFormProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    setLineOfBusiness(INSURANCE_PRODUCTS[1]);
  }, [setLineOfBusiness]);

  // useEffect(() => {
  //   setErrorList([]);
  // }, []);

  return (
    <div>
      <Vehicle
        onNextTab={onNextTab}
        onPrevTab={onPrevTab}
        currentIndex={currentIndex}
        history={history}
        add={add}
        goToLastTab={goToLastTab}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch: any): AppComponents.AutoFormDispatch =>
  bindActionCreators({ setLineOfBusiness, setErrorList }, dispatch);

export default connect(null, mapDispatchToProps)(AutoForm);
